angular.module('impactx.search').directive('ixSearchInputGlobal', function() {
    return {
        restrict: 'E',
        controller: 'SearchInputCtrl',
        controllerAs: 'ctrl',
        scope: {
            global: "="
        },
        templateUrl: 'modules/search/templates/search.input.global.html'
    }
});